// 环境变量配置
const env = process.env.NODE_ENV || 'development'

// 不同环境的配置
const envConfig = {
  development: {
    baseApi: '/api', // 开发环境使用本地代理地址
    imageUrl: 'https://www.jszhijin.com/w/api', // 开发环境图片地址也使用代理
    uploadUrl: 'http://localhost:3000/upload' // 开发环境上传地址
  },
  production: {
    baseApi: 'https://www.jszhijin.com/w/api', // 生产环境API地址
    imageUrl: 'https://www.jszhijin.com/w/api', // 生产环境图片地址
    // uploadUrl: 'https://api.yourdomain.com/upload' // 生产环境上传地址
  }
}

// 导出当前环境的配置
export default {
  env,
  ...envConfig[env],
  // 其他全局配置
  tokenKey: 'token',
  userInfoKey: 'userInfo',
  // 请求超时时间
  timeout: 15000,
  // 分页配置
  pageSize: 10,
  pageSizes: [10, 20, 50, 100]
} 